export default {
    'searchList': {
        'searchTxt': [{
            'name': '罚扣款单号',
            'value': 'supFineNo',
            'type': 'input',
            'unfold': true,
            'span': 3
        },
        {
            'name': '服务平台',
            'value': 'siteName',
            'unfold': true,
            'advanceConfig': [
                { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称' },
                { 'prop': 'escoCompanyNo', 'value': '服务平台编码' }
            ],
            'tableConfig': [
                { 'prop': 'escoCompanyNo', 'value': '服务平台编码' },
                { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称' }
            ],
            'advanceUrl': '/searchPlatform',
            'type': 'advance',
            'cbParams': ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
            'span': 3
        },
        {
            'name': '分公司',
            'value': 'siteOfficeName',
            'unfold': true,
            'advanceConfig': [
                { 'prop': 'companyNameCn', 'value': '分公司名称' },
                { 'prop': 'companyCode', 'value': '分公司编码' }
            ],
            'tableConfig': [
                { 'prop': 'companyNameCn', 'value': '分公司名称' },
                { 'prop': 'companyCode', 'value': '分公司编码' }
            ],
            'advanceUrl': '/esCompany/popCompany',
            'type': 'advance',
            'cbParams': ['companyCode#companyCode', 'companyNameCn#siteOfficeName'],
            'span': 3
        },
        {
            'name': '状态',
            'value': 'status',
            'type': 'select',
            'unfold': true,
            'span': 3,
            'optionNum': 'SYS_BMS_SUPP_FINE_STATUS',
            'multiple': false
        },
        {
            'name': '创建时间',
            'value': 'createTime',
            'startTime': 'createTimeFrom',
            'endTime': 'createTimeTo',
            'startPlaceholder': '创建开始日期',
            'endPlaceholder': '创建结束日期',
            'type': 'time',
            'unfold': true,
            'timeNum': 30,
            'span': 6
        }],
        'unfoldState': false,
        'advancedBtn': true
    },
    'searchTotalTitle': [
        {
            'name': '业务类型',
            'value': 'operationType',
            'type': 'select',
            'unfold': true,
            'span': 3,
            'optionNum': 'BID_BUSINESS_TYPE',
            'multiple': false
        }
    ],
    'table':
    {
        'clickState': false,
        'selectBtn': true,
        'height': 400,
        'fixedSeletionColumn': true,
        'columns': [
            {
                'label': '分公司',
                'prop': 'companyName',
                'width': '150px'
            },
            {
                'label': '服务平台',
                'prop': 'siteName',
                'width': '100px'
            },
            {
                'label': '会计主体',
                'prop': 'ledgerName',
                'width': '255px'
            },
            {
                'label': '业务类型',
                'prop': 'operationType',
                'width': '75px',
                'type': 'select',
                'optionNum': 'BID_BUSINESS_TYPE',
                'options': []
            },
            {
                'label': '扣款类型',
                'prop': 'operateRecoupName',
                'width': '75px'
            },
            {
                'label': '罚扣款单号',
                'prop': 'supFineNo',
                'width': '150px'
            },
            {
                'label': '状态',
                'prop': 'status',
                'width': '50px',
                'type': 'select',
                'optionNum': 'SYS_BMS_SUPP_FINE_STATUS',
                'options': []
            },
            {
                'label': '客户名称',
                'prop': 'custName',
                'width': '200px'
            },
            {
                'label': '业务单号',
                'prop': 'businessOrderNo',
                'width': '170px'
            },
            {
                'label': '客户订单号',
                'prop': 'customerOrderNo',
                'width': '160px'
            },
            {
                'label': '发车单号',
                'prop': 'etdoNo',
                'width': '150px'
            },
            {
                'label': '产品名称',
                'prop': 'cdcmNameCn',
                'width': '100px'
            },
            {
                'label': '扣款金额',
                'prop': 'detailInitialAmt',
                'width': '75px'
            },
            {
                'label': '单价',
                'prop': 'price',
                'width': '80px'
            },
            {
                'label': '数量',
                'prop': 'quantity',
                'width': '60px'
            },
            {
                'label': '扣款原因',
                'prop': 'fineCause',
                'width': '200px'
            },
            {
                'label': '创建时间',
                'prop': 'createTime',
                'width': '150px'
            }
        ],
        'leftOperation': false
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10
        // 'pageSizes': [10, 20, 30, 50, 100]
    }
};
